/**
 * Scroll-to functionality for hash links on the document
 *
 * @package Embark
 * @since   1.0.0
 */

import $ from 'jquery';
import * as helpers from '../global/helpers';
import { els, breakpoints } from './variables';

const glossaryNav = document.querySelector('.em-glossary__nav');
const glossaryTermHeader = document.querySelector('.em-glossary__terms-header');
const ppcLanding = document.querySelector('.tmpl-ppc-landing-page');
const pageNav = document.querySelector('.em-page-navigation');

function getScrollOffset(target) {
	let offset = els.header.classList.contains('has-notice') ? els.header.offsetHeight : els.headerInner.offsetHeight;

	// Update the offset if we are on the glossary page.
	if (!target.hasClass('em-glossary__section') && glossaryNav && glossaryTermHeader) {
		if (breakpoints.sm.aboveMin()) {
			offset += glossaryNav.offsetHeight + glossaryTermHeader.offsetHeight + 50;
		} else {
			offset += glossaryTermHeader.offsetHeight + 50;
		}
	}

	// Offset fix for PPC Landing Page.
	if (ppcLanding && breakpoints.sm.belowMin()) {
		offset -= 700;
	}

	if (pageNav) {
		if (breakpoints.sm.aboveMin()) {
			offset += pageNav.offsetHeight + 20;
		} else {
			offset += pageNav.offsetHeight + 10;
		}
	}

	return offset;
}

/**
 * Scroll to hash on load.
 *
 * @since  1.0.0
 */
function scrollToHashOnLoad() {
	const { hash } = window.location;
	if (hash) {
		// To top right away.
		window.scroll(0, 0);
		// Void some browsers issue.
		setTimeout(() => {
			window.scroll(0, 0);
		}, 1);

		let target = $(hash);
		target = target.length ? target : $(`[name=${hash.slice(1)}]`);

		if (target.length) {
			// If the target is a tab title, and it isn't visible, then get the parent tabs block.
			if (target.hasClass('em-title-item') && !target[0].offsetParent) {
				target = target.closest('.em-tabs-wrap');
			}
			helpers.scrollToEl(target, getScrollOffset(target));
			if ($('.wp-block-emagine-tabs') && $(`.em-tabs-content-wrap a[href="${hash}"]`).length) {
				$('.em-tabs-content-wrap div').removeClass('em-tab-title-active');
				$(`.em-tabs-content-wrap a[href="${hash}"]`).parent().addClass('em-tab-title-active');
				const tab = $(`a[href="${hash}"].em-tab-title`).data('tab');
				const count = $('.em-tab-title').length;
				let i = 1;
				while (i < count) {
					if ($('.em-tabs-wrap').hasClass(`em-active-tab-${i}`)) {
						$('.em-tabs-wrap').removeClass(`em-active-tab-${i}`);
					}
					i++;
				}
				$('.em-tabs-wrap').addClass(`em-active-tab-${tab}`);
			}
		}
	}
}

/**
 * Scroll to hash on click, and update URL.
 *
 * @since  1.0.0
 */
function scrollToHashOnClick(e) {
	if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
		const { hash } = this;
		let target = $(hash);
		target = target.length ? target : $(`[name=${hash.slice(1)}]`);

		if (target.length) {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				// If mobile the structure of the accordions is differet, so we need to handle it differently
				if (e.target.classList.contains('em-tab-title') || e.target.classList.contains('em-title-text')) {
					target = $(`a[href="${hash}"]`).closest('.em-tabs-content-wrap');
				}
			} else if (e.target.classList.contains('em-tab-title') || e.target.classList.contains('em-title-text')) {
				const parent = e.target.parentElement;
				if (parent.classList.contains('em-tabs-accordion-title')) {
					target = $(parent);
				} else {
					target = $(e.target).closest('.em-tabs-wrap');
				}
			}
		}

		helpers.scrollToEl(target, getScrollOffset(target));
		helpers.addHashToURL(hash);
		if ($('.wp-block-emagine-tabs') && $(`.em-tabs-title-list a[href="${hash}"]`)) {
			$('.em-tabs-title-list li').removeClass('em-tab-title-active');
			$(`.em-tabs-title-list a[href="${hash}"]`).parent().addClass('em-tab-title-active');
			const tab = $(`a[href="${hash}"].em-tab-title`).data('tab');
			const count = $('.em-tab-title').length;
			let i = 1;
			while (i < count) {
				if ($('.em-tabs-wrap').hasClass(`em-active-tab-${i}`)) {
					$('.em-tabs-wrap').removeClass(`em-active-tab-${i}`);
				}
				i++;
			}
			$('.em-tabs-wrap').addClass(`em-active-tab-${tab}`);
		}

		return false;
	}
	return true;
}

window.addEventListener('load', scrollToHashOnLoad);
$(document).on('click', 'a[href*=\\#]:not([href=\\#])', scrollToHashOnClick);
